import React from 'react';

import classes from 'classnames';

import Icon from 'components/shared/Icon';
import RightFill from 'components/shared/Icon/icons/RightFill';
import { decamelize } from 'utils/humps';

import styles from './index.module.css';

function ColHeader({ title, orderBy, order, onOrder, column }) {
  const orderName = decamelize(column.id);
  const isSorted = orderName === orderBy;
  const isSortedDesc = order !== 'asc';

  const iconClasses = isSorted ? (isSortedDesc ? styles.iconRotateDown : styles.iconRotateUp) : '';
  const handleOrder = () => {
    const newOrder = isSorted ? (isSortedDesc ? '' : 'desc') : 'asc';
    onOrder(orderName, newOrder);
  };

  return (
    <div className={styles.colHeader} onClick={handleOrder}>
      <span className={styles.title}>{title}</span>
      <Icon component={RightFill} className={classes(styles.icon, iconClasses)} width="6" height="12" />
    </div>
  );
}

export default ColHeader;
